/* eslint-disable no-param-reassign */
export default {
  state: {
    sede: null,
    evento: null,
    telefonoPaciente: null,
    orderId: null,
    nombrePrestacion: null,
    cups: null,
    fechaHoraCita: null,
  },
  getters: {
    getSede: state => state.sede,
    getEvento: state => state.evento,
    getTelefonoPaciente: state => state.telefonoPaciente,
    getOrdenId: state => state.orderId,
    getNombrePrestacion: state => state.nombrePrestacion,
    getCups: state => state.cups,
    getFechaHoraCita: state => state.fechaHoraCita,
  },
  mutations: {
    setSede(state, estado) {
      state.sede = estado;
    },
    setEvento(state, estado) {
      state.evento = estado;
    },
    setTelefonoPaciente(state, estado) {
      state.telefonoPaciente = estado;
    },
    setOrdenId(state, estado) {
      state.orderId = estado;
    },
    setNombrePrestacion(state, estado) {
      state.nombrePrestacion = estado;
    },
    setCups(state, estado) {
      state.cups = estado;
    },
    setFechaHoraCita(state, estado) {
      state.fechaHoraCita = estado;
    },
  },
  actions: {
    setSede(context, estado) {
      context.commit('setSede', estado);
    },
    setEvento(context, estado) {
      context.commit('setEvento', estado);
    },
    setTelefonoPaciente(context, estado) {
      context.commit('setTelefonoPaciente', estado);
    },
    setOrdenId(context, estado) {
      context.commit('setOrdenId', estado);
    },
    setNombrePrestacion(context, estado) {
      context.commit('setNombrePrestacion', estado);
    },
    setCups(context, estado) {
      context.commit('setCups', estado);
    },
    setFechaHoraCita(context, estado) {
      context.commit('setFechaHoraCita', estado);
    },
  },
};



// WEBPACK FOOTER //
// ./src/js/modules/storeAgendamiento.js